const SaltLogo = ({
	height = 24,
	width = 45,
	color = "white",
}: {
	height?: number;
	width?: number;
	color?: string;
}) => (
	<svg
		width={width}
		height={height}
		viewBox="0 0 42 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{
			transition: `all .3s ease-in-out`,
		}}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M29.4828 0.5C29.7233 0.5 29.9182 0.694943 29.9182 0.935417V23.0646C29.9182 23.3051 29.7233 23.5 29.4828 23.5C29.2423 23.5 29.0474 23.3051 29.0474 23.0646V0.935417C29.0474 0.694943 29.2423 0.5 29.4828 0.5Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M36.0184 4.60938C36.2589 4.60938 36.4538 4.80432 36.4538 5.04479V19.2899C36.4677 20.3812 36.8479 21.1892 37.5421 21.7363C38.2521 22.2959 39.3475 22.6271 40.8689 22.6271H41.1694C41.4099 22.6271 41.6048 22.822 41.6048 23.0625C41.6048 23.303 41.4099 23.4979 41.1694 23.4979H40.8689C39.2381 23.4979 37.9229 23.1452 37.003 22.4203C36.0679 21.6833 35.599 20.6073 35.583 19.298C35.583 19.2962 35.583 19.2944 35.583 19.2927V5.04479C35.583 4.80432 35.778 4.60938 36.0184 4.60938Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M32.3394 8.66784C32.3394 8.42736 32.5343 8.23242 32.7748 8.23242H41.1675C41.408 8.23242 41.6029 8.42736 41.6029 8.66784C41.6029 8.90831 41.408 9.10326 41.1675 9.10326H32.7748C32.5343 9.10326 32.3394 8.90831 32.3394 8.66784Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M1.37501 12.2505C1.37558 11.4591 1.8037 10.6942 2.57974 10.1123C3.35591 9.53029 4.46144 9.15013 5.73844 9.15013C7.01524 9.15013 8.12068 9.5302 8.89686 10.1121C9.67341 10.6943 10.1017 11.4597 10.1018 12.2518C10.1019 12.4922 10.2969 12.6871 10.5374 12.6871C10.7778 12.687 10.9727 12.4921 10.9727 12.2516C10.9724 11.125 10.3618 10.122 9.41923 9.41535C8.47632 8.70843 7.18255 8.2793 5.73844 8.2793C4.29411 8.2793 3.00023 8.70853 2.05731 9.41557C1.11477 10.1223 0.504179 11.1255 0.504179 12.2521C0.504179 12.2531 0.504182 12.2542 0.50419 12.2552C0.512796 13.455 1.27168 14.2715 2.23844 14.8594C3.19838 15.4432 4.45599 15.8606 5.64717 16.243C5.65735 16.2463 5.66764 16.2492 5.67801 16.2517C5.73141 16.269 5.78478 16.2862 5.83808 16.3034C7.06146 16.6981 8.25266 17.0825 9.15697 17.5945C10.1055 18.1316 10.6107 18.7347 10.6048 19.5227C10.6048 19.5238 10.6048 19.5249 10.6048 19.526C10.6048 20.3018 10.1514 21.0658 9.28998 21.6542C8.43009 22.2416 7.19345 22.6275 5.73763 22.6275C4.28203 22.6275 3.04549 22.2416 2.18564 21.6542C1.3243 21.0658 0.870834 20.3018 0.870834 19.526C0.870834 19.2855 0.675891 19.0906 0.435417 19.0906C0.194943 19.0906 0 19.2855 0 19.526C0 20.6683 0.668987 21.6728 1.69442 22.3733C2.72136 23.0748 4.13592 23.4983 5.73763 23.4983C7.33953 23.4983 8.7542 23.0748 9.78118 22.3733C10.8062 21.6731 11.475 20.6693 11.4757 19.5277C11.4844 18.264 10.6332 17.4296 9.58603 16.8367C8.60125 16.2792 7.33037 15.8695 6.13819 15.4851C6.06453 15.4614 5.99116 15.4377 5.91818 15.4141C5.90753 15.4107 5.89676 15.4077 5.8859 15.4051C4.68565 15.0194 3.54095 14.6323 2.69092 14.1153C1.8418 13.599 1.3811 13.0132 1.37501 12.2505Z"
			fill={color}
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M19.7264 4.60966C19.8784 4.60419 20.0222 4.67841 20.1058 4.80544L26.3074 14.2298C26.3573 14.3056 26.3822 14.3951 26.3787 14.4857L26.2612 17.565C26.2596 17.6067 26.252 17.6481 26.2386 17.6877L24.978 21.4201C24.9409 21.5301 24.8614 21.6207 24.7571 21.6717L21.1395 23.4446C21.0205 23.503 20.8814 23.5039 20.7616 23.4472L16.2544 21.3124C16.1667 21.2709 16.0954 21.2012 16.0518 21.1145L14.3573 17.7439C14.3303 17.6902 14.3147 17.6314 14.3115 17.5713L14.1393 14.3054C14.1349 14.2233 14.154 14.1417 14.1941 14.0699L19.3621 4.83221C19.4363 4.69949 19.5744 4.61513 19.7264 4.60966ZM19.8127 6.31654L17.1429 15.1541L20.6664 17.9967L23.6153 15.2015L19.8127 6.31654ZM24.0809 15.96L21.1359 18.7516L21.3449 22.3742L24.211 20.9696L25.3399 17.6271L24.0809 15.96ZM25.4376 16.3114L24.5143 15.0888L22.0663 9.36901L25.5032 14.5919L25.4376 16.3114ZM20.471 22.346L20.2947 19.2899L17.3957 20.8894L20.471 22.346ZM16.6266 20.3191L15.2646 17.6099L16.6989 15.9149L19.9116 18.5067L16.6266 20.3191ZM16.2506 15.0966L18.1676 8.75102L15.0155 14.3852L15.1233 16.4288L16.2506 15.0966Z"
			fill={color}
		/>
	</svg>
);

export default SaltLogo;
